import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  value: {
    steps: [],
    run: false,
    activeIndex: null,
    is_new_org: false,
  },
};

const tourSlice = createSlice({
  name: "tour",
  initialState,
  reducers: {
    setSteps(state, action) {
      if (action.payload.steps?.length > 0) {
        state.value.steps = action.payload.steps;
        state.value.activeIndex = 0;
      } else {
        state.value.steps = [];
        state.value.activeIndex = null;
        state.value.run = false;
      }
    },
    updateNextTourIndex(state) {
      if (state.value.activeIndex < state.value.steps?.length - 1) {
        state.value.activeIndex = state.value.activeIndex + 1;
      }
    },
    updatePreviousTourIndex(state) {
      if (state.value.activeIndex > 0) {
        state.value.activeIndex = state.value.activeIndex - 1;
      }
    },
    startTour(state) {
      state.value.run = true;
      if(state.value.steps?.length > 0){
        state.value.activeIndex = 0;
      }else{
        state.value.activeIndex = null;
        state.value.run = false;
      }
    },
    stopTour(state) {
      state.value.run = false;
      
      state.value.activeIndex = null;
    },
    updateIsNewOrg(state, data) {
      state.value.is_new_org = data.payload;
    },
  },
});

export const {
  setSteps,
  startTour,
  stopTour,
  updateNextTourIndex,
  updatePreviousTourIndex,
  updateIsNewOrg,
} = tourSlice.actions;
export default tourSlice.reducer;
